module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-brands-400-d72293118cda50ec50c39957d9d836d0.svg";